<template>
  <div class="pa-2" style="width: 50%">
    <div v-if="plan" class="d-flex flex-column ga-1">
      <span><b>Status:</b> {{ plan.status }}</span>
      <span><b>Created On:</b> {{ plan.created.toLocaleString() }}</span>
      <span v-if="publishedName">
        <b>Published By:</b> {{ publishedName }}
      </span>
      <span v-if="plan.published_timestamp">
        <b>Published On:</b>
        {{ plan.published_timestamp.toLocaleString() }}
      </span>
    </div>

    <v-table
      v-if="
        plan?.asset_management_plan_master &&
        plan.asset_management_plan_master.approval_stages.length > 0
      "
      class="mt-4"
    >
      <thead>
        <tr>
          <th>Order</th>
          <th>Approvers</th>
          <th>Status</th>
          <th>Comment</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="stage in plan.asset_management_plan_master.approval_stages"
          :key="stage.id"
        >
          <td>{{ stage.order + 1 }}</td>
          <td>{{ stage.formatApprovers(users) }}</td>
          <td>
            <v-tooltip location="bottom" :text="stage.status_tooltip">
              <template #activator="{ props }">
                <v-chip
                  v-bind="stage.status_tooltip ? props : {}"
                  :color="
                    stage.status === 'Approved'
                      ? 'green'
                      : stage.status === 'Rejected'
                      ? 'red'
                      : ''
                  "
                  label
                >
                  {{ stage.status }}
                </v-chip>
              </template>
            </v-tooltip>
          </td>
          <td>{{ stage.comment }}</td>
        </tr>
      </tbody>
    </v-table>
  </div>
</template>

<script setup lang="ts">
import { AssetManagementPlan, User } from "@/classes";
import { useListStore } from "@/store/lists";
import { computed } from "vue";

const props = defineProps<{
  plan: AssetManagementPlan | null;
  diffPlan?: AssetManagementPlan | null;
  diff?: boolean;
}>();

const lists = useListStore();
const users = lists.useList<User>("users");

const publishedName = computed(() => {
  return (
    users.value.find((user) => user.id === props.plan?.publisher_id)?.name || ""
  );
});
</script>
